import gql from "graphql-tag";

export const NOMINEE_SEND_CUSTOMER_INVITE = gql`
  mutation NomineeSendCustomerInvite($userId: ID!) {
    sendCustomerInvite(userId: $userId) {
      feedback
    }
  }
`;
